<template>
  <button
    type="button"
    :class="classes"
    title="Add to cart"
    @click="onClick"
  >
    <add-to-cart-check v-if="showCheck" />
    <add-to-cart-spinner v-else-if="showSpinner" />
    <add-to-cart-icon v-else />
  </button>
</template>

<script>
// @flow

import { mapState } from 'vuex'

import { logger } from '../../../../../../../../common'
import { createClickout } from '../../../../../../../../common/api/chatchampApi'

import AddToCartIcon from '../../AddToCartIcon.vue'
import AddToCartSpinner from '../../AddToCartSpinner.vue'
import AddToCartCheck from '../../AddToCartCheck.vue'

export default {
  components: {
    AddToCartIcon,
    AddToCartSpinner,
    AddToCartCheck
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState(['customerId', 'subscriberId', 'productAddingToCart', 'cartProducts']),
    classes () {
      return {
        'add-to-cart-button': true,
        'add-to-cart-button--is-disabled': this.showSpinner || this.showCheck
      }
    },
    showCheck (): boolean {
      return this.cartProducts.includes(this.item.productIdentifier)
    },
    showSpinner (): boolean {
      return this.item.productIdentifier === this.productAddingToCart
    }
  },
  methods: {
    async onClick () {
      const { productId, productIdentifier, growthToolId } = this.item
      logger.info(`Subscriber add to cart product identifier ${productIdentifier}...`)
      createClickout(this.customerId, this.subscriberId, this.message.content.messageId, {
        buttonType: 'postback',
        productId
      })
      if (growthToolId) {
        await this.$store.dispatch('welcomeMessageShownById', growthToolId)
        this.$store.commit('setLastMessageReceived', null)
      }
      this.$emit('product-added-to-cart', {
        product: this.item,
        productId: productIdentifier,
        chatbotId: this.message.content.chatbotId
      })
    }
  }
}
</script>
